import { SearchFilterType } from '~/components/TableFilters/types';
import { relationshipSummaryModel } from '~/models';
import { getStatusUIData, proposalStatusDefinition, sortFunctions } from './ProposalsDashboard.utils';
import { FilterType, HeaderColId } from './ProposalsDashboardOld';
export const PROPOSAL_COLUMN_NAMES = [
    'companyName',
    'sentDate',
    'sentBy',
    'status'
];
export const DEFAULT_PROPOSALS_SORT = {
    name: 'sentDate',
    direction: 'desc'
};
export const COLUMN_ID_BY_ROW_FIELD = {
    companyName: HeaderColId.CompanyName,
    sentDate: HeaderColId.SentDate,
    sentBy: HeaderColId.SentBy,
    status: HeaderColId.Status
};
export const toProposalRows = (param)=>{
    let { proposals, isVendor, texts } = param;
    return proposals.map((proposal)=>{
        var _relationshipSummaryModel_displayedTitle, _relationshipSummaryModel_sellerFullName;
        return {
            id: proposal.id,
            companyName: relationshipSummaryModel.opposingPartyName(proposal, isVendor),
            proposalTitle: (_relationshipSummaryModel_displayedTitle = relationshipSummaryModel.displayedTitle(proposal, isVendor)) !== null && _relationshipSummaryModel_displayedTitle !== void 0 ? _relationshipSummaryModel_displayedTitle : '',
            sentDate: proposal.createdOn,
            sentBy: (_relationshipSummaryModel_sellerFullName = relationshipSummaryModel.sellerFullName(proposal)) !== null && _relationshipSummaryModel_sellerFullName !== void 0 ? _relationshipSummaryModel_sellerFullName : '',
            status: getStatusUIData(proposal, isVendor, texts).statusText
        };
    });
};
export const proposalStatusSkin = (param)=>{
    let { proposals, isVendor, texts } = param;
    const skinByLabel = {};
    const infoByLabel = {};
    proposals.forEach((proposal)=>{
        const { statusText, badgeSkin, lastUpdateText } = getStatusUIData(proposal, isVendor, texts);
        skinByLabel[statusText] = badgeSkin;
        if (lastUpdateText) infoByLabel[statusText] = lastUpdateText;
    });
    return {
        skinByLabel,
        infoByLabel
    };
};
export const proposalColumns = (param)=>{
    let { texts, skinByLabel, infoByLabel } = param;
    return [
        {
            type: 'date',
            name: 'sentDate',
            header: texts.columnHeaders.sentDate(),
            sortable: true,
            bi: {
                name: 'proposals_by_sent_date'
            }
        },
        {
            type: 'text',
            name: 'sentBy',
            header: texts.columnHeaders.sentBy(),
            width: {
                initial: 150,
                min: 150
            },
            sortable: true,
            bi: {
                name: 'proposals_by_sent_by'
            }
        },
        {
            type: 'badge',
            name: 'status',
            header: texts.columnHeaders.status(),
            width: {
                initial: 230,
                min: 230
            },
            useColor: (label)=>{
                var _skinByLabel_label;
                return (_skinByLabel_label = skinByLabel[label]) !== null && _skinByLabel_label !== void 0 ? _skinByLabel_label : 'default';
            },
            useInfo: (label)=>infoByLabel[label],
            sortable: true,
            bi: {
                name: 'proposals_by_status'
            }
        }
    ];
};
export const proposalMainColumn = (texts)=>({
        type: 'text',
        name: 'companyName',
        header: texts.columnHeaders.companyName(),
        width: {
            initial: 300,
            min: 300
        },
        weight: 'normal',
        subtitle: (row)=>[
                row.proposalTitle
            ],
        sortable: true,
        bi: {
            name: 'proposals_by_company_name'
        }
    });
export const proposalMobileCard = (texts)=>({
        fields: [
            {
                name: 'companyName'
            },
            {
                name: 'sentBy',
                label: texts.columnHeaders.sentBy(),
                hideColon: true,
                joinWith: 'sentDate'
            },
            {
                name: 'status',
                inline: true
            }
        ]
    });
export const toProposalMenuRow = (proposal)=>({
        id: proposal.id,
        draftId: proposal.draftId,
        isSample: proposal.isSample,
        vendorId: proposal.vendor.id,
        customerId: proposal.customer.id,
        progressStatus: proposal.progressStatus,
        hasSignatureToS: proposal.hasSignatureToS
    });
export const visibleProposals = (param)=>{
    let { proposals, isVendor, texts, statusFilter, sentByFilter, search, sort } = param;
    const normalizedSearch = search.trim().toLowerCase();
    const filtered = proposals.filter((proposal)=>{
        const searchable = "".concat(relationshipSummaryModel.opposingPartyName(proposal, isVendor), " ").concat(proposal.title);
        const passesStatus = statusFilter.length === 0 || statusFilter.includes(getStatusUIData(proposal, isVendor, texts).viewableStatus);
        const passesSentBy = sentByFilter.length === 0 || sentByFilter.includes(proposal.seller.id);
        return passesStatus && passesSentBy && (!normalizedSearch || searchable.toLowerCase().includes(normalizedSearch));
    });
    const columnIndex = PROPOSAL_COLUMN_NAMES.indexOf(sort.name);
    return [
        ...filtered
    ].sort(sortFunctions[columnIndex]({
        isVendor,
        isAscending: sort.direction === 'asc',
        proposalsTexts: texts
    }));
};
export const proposalStatusFilterOptions = (param)=>{
    let { counters, isVendor, texts } = param;
    const statusDefinition = proposalStatusDefinition(isVendor, texts);
    const availableStatuses = Object.keys(counters);
    return Object.keys(statusDefinition).filter((status)=>availableStatuses.includes(status)).sort((a, b)=>statusDefinition[b].severity - statusDefinition[a].severity).map((statusName)=>({
            label: statusDefinition[statusName].statusText,
            value: statusName,
            counter: counters[statusName]
        }));
};
export const proposalSentByOptions = (proposals)=>{
    const sellerMap = proposals.reduce((acc, param)=>{
        let { seller: { id, firstName, lastName } } = param;
        return firstName != null && lastName != null ? Object.assign(acc, {
            [id]: "".concat(firstName, " ").concat(lastName)
        }) : acc;
    }, {});
    return Object.entries(sellerMap).sort((param, param1)=>{
        let [, a] = param, [, b] = param1;
        return a.localeCompare(b);
    }).map((param)=>{
        let [id, name] = param;
        return {
            label: name,
            value: id
        };
    });
};
export const proposalFilterConfig = (param)=>{
    let { statusOptions, sentByOptions } = param;
    return {
        [FilterType.Status]: {
            type: SearchFilterType.MultiSelectFilter,
            options: statusOptions,
            removable: false
        },
        [FilterType.SentBy]: {
            type: SearchFilterType.MultiSelectFilter,
            options: sentByOptions,
            removable: false
        }
    };
};
